import { getTokens } from "./authStore";

const AUTH_SERVER = import.meta.env.VITE_APP_AUTH_SERVER_URI;

/**
 * Re-send (or send) the first-login invitation for a profile. This is a REST
 * call to the auth-server (`POST /invitation/:profileUuid`), not a GraphQL
 * mutation. Throws on a non-2xx response so callers can surface an error toast.
 *
 * `frontendUrl` is the URL of the tool the invitation is for (its
 * `Application.uri`): the auth-server stores it with the invitation, sends the
 * person there after the signup and links there from the confirmation mail.
 * Without one the auth-server's own URL is sent, and the person lands on the
 * login dashboard.
 */
export async function sendInvitation(
  profileUuid: string,
  email: string,
  product = "bp",
  frontendUrl?: string,
): Promise<void> {
  const res = await fetch(`${AUTH_SERVER}/invitation/${profileUuid}`, {
    method: "POST",
    headers: {
      "content-type": "application/json",
      authorization: `Bearer ${getTokens()?.access_token ?? ""}`,
    },
    body: JSON.stringify({ profileUuid, email, product, baseUrl: frontendUrl || AUTH_SERVER }),
  });
  if (!res.ok) {
    throw new Error(`HTTP ${res.status}`);
  }
}
